<script>
	export let activePage = 'pradzia';
	export let onPageChange = (pageId) => {};

	// Navigation items data structure
	const navItems = [
		{ id: 'pradzia', label: 'Pradžia', icon: 'home' },
		{ id: 'biblioteka', label: 'Biblioteka', icon: 'book-open' },
		{ id: 'egzaminai', label: 'Egzaminai', icon: 'file-text' },
		{ id: 'uzduociu-bankas', label: 'Užduočių Bankas', icon: 'database' },
		{ id: 'ikelti', label: 'Įkelti užduotį', icon: 'upload' },
	];

	// Icon components as SVG strings
	const icons = {
		home: `<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>`,
		'book-open': `<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>`,
		'file-text': `<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>`,
		database: `<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>`,
		upload: `<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>`,
	};

	function handleClick(pageId) {
		onPageChange(pageId);
	}
</script>

<aside class="sidebar">
	<div class="sidebar-header">
		<h1>Užduočių Bankas</h1>
	</div>

	<nav class="sidebar-nav">
		<ul class="nav-list">
			{#each navItems as item}
				<li>
					<button
						class="nav-button"
						class:active={activePage === item.id}
						on:click={() => handleClick(item.id)}
					>
						<svg
							class="nav-icon"
							width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							{@html icons[item.icon]}
						</svg>
						<span>{item.label}</span>
					</button>
				</li>
			{/each}
		</ul>
	</nav>
</aside>

<style>
	.sidebar {
		width: 256px;
		background-color: white;
		border-right: 1px solid #e5e7eb;
		display: flex;
		flex-direction: column;
	}

	.sidebar-header {
		padding: 24px;
		border-bottom: 1px solid #e5e7eb;
	}

	.sidebar-header h1 {
		margin: 0;
		color: #111827;
		font-size: 18px;
		font-weight: 600;
	}

	.sidebar-nav {
		flex: 1;
		padding: 16px;
	}

	.nav-list {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.nav-button {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px 16px;
		border-radius: 8px;
		border: none;
		background: transparent;
		color: #374151;
		cursor: pointer;
		transition: all 0.2s ease;
		font-size: 14px;
		font-family: inherit;
	}

	.nav-button:hover:not(.active) {
		background-color: #f9fafb;
	}

	.nav-button.active {
		background-color: #fff7ed;
		color: #fab45a;
	}

	.nav-icon {
		flex-shrink: 0;
	}

	/* Responsive Design */
	@media (max-width: 768px) {
		.sidebar {
			width: 100%;
			border-right: none;
			border-bottom: 1px solid #e5e7eb;
		}

		.sidebar-nav {
			padding: 8px;
		}

		.nav-list {
			flex-direction: row;
			overflow-x: auto;
			gap: 4px;
		}

		.nav-button {
			white-space: nowrap;
			padding: 8px 12px;
		}
	}
</style>
